import * as Sentry from "@sentry/react";

/**
 * A task_activity mirror insert failed AFTER the tasks.notes write already
 * succeeded (the four writer flows persist the note to the tasks.notes column
 * first, then best-effort mirror it into the task_activity timeline).
 *
 * The note itself stays visible — TaskDetailsModal renders tasks.notes
 * directly — but the timeline entry (actor attribution, per-note timestamp,
 * structured payload) is lost. Historically this was a bare console.warn,
 * which is how 20+ prod notes went missing from admin timelines with zero
 * signal. Capture to Sentry, tagged by flow, so a broken mirror is alertable.
 */
export function reportTaskActivityMirrorFailure(
  flow: "note" | "feedback" | "supervision_closeout" | "assessment_closeout",
  taskId: string,
  err: unknown,
) {
  console.warn(`task_activity mirror failed for ${flow}`, err);
  Sentry.captureException(err, {
    level: "warning",
    tags: { feature: "task_activity_mirror", flow },
    extra: { taskId },
  });
}
